/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: about-us.page.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Pages from '@/shared/page';
import SEOMetadata from '@/constants/seo';
import App from '@/constants/app';
import Sections from '@/sections';
import Links from '@/constants/links';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const ContactUsPage: FunctionComponent = () => {
  const { t } = useTranslation('contact-us');

  const headParams = {
    title: `${t('head.title')} | ${App.Name.toUpperCase()}`,
    description: SEOMetadata.description,
    ogType: 'website',
    structuredData: JSON.stringify({
      '@context': `${SEOMetadata.siteUrl}${Links.Public.CONTACT_US}`,
      description: SEOMetadata.description
    })
  };

  return (
    <Pages.Fade headParams={headParams}>
      <Sections.Intros.Contact />
      <Sections.Contact />
      <Sections.Footer.BottomNavigation />
      <Sections.Footer.Copyright />
    </Pages.Fade>
  );
};

export default ContactUsPage;
